export default "__VITE_ASSET__DgPn8RVd__$_?url__"